// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__YPDhk","icon":"SortAdornment_icon__KLab5","up":"SortAdornment_up__V4FkQ","down":"SortAdornment_down__3JlL8","active":"SortAdornment_active__1p7pD"};